import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

export interface ProgressBarProps extends Omit<ComponentProps<'div'>, 'children'> {
  /** 0–100; clamped. */
  value: number;
  fillClassName?: string;
}

/** 8px bar on the subtle track; fills from the inline start, so it follows RTL. */
export function ProgressBar({
  value,
  fillClassName = 'bg-progress-fill',
  className,
  ...props
}: ProgressBarProps) {
  const percent = Math.min(100, Math.max(0, value));

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(percent)}
      data-slot="progress-bar"
      className={cn('h-2 w-full overflow-hidden rounded-full bg-border-subtle', className)}
      {...props}
    >
      <div
        className={cn('h-full rounded-full transition-[width] duration-500', fillClassName)}
        style={{width: `${percent}%`}}
      />
    </div>
  );
}
